import { api } from "../../services/Api.js";
import { modalService } from '../../services/ModalService.js';
import i18n from '../../language.js';

/* GET A PHOTO WITH PROXY TO DOWNLOAD */
export function get_crossdomain_photo( {state} , payload ){

    // payload.url
    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    var loader=modalService.createLoader(i18n.t("language.downloading_content"));
    
    return api
    .post(school,"get_crossdomain_photo.php",payload)
    .then( result =>{ 
      
      // setting the correct mimetype for base 64 data
      if (payload.img_url.toLowerCase().includes(".jpg")){
        result.data.img="data:image/jpeg;base64,"+result.data.img;
      }
      if (payload.img_url.toLowerCase().includes(".png")){
        result.data.img="data:image/png;base64,"+result.data.img;
      }

      setTimeout(()=>{
        loader.close();
      },1000);

      return result;// maike chainable
    })

  

}